import {
    clearFlowFields,
    selectorOrder,
    setActiveTariff,
    setAvailableTariffs
} from "../features/QueuePaymenrt/slices/OrderSlice";
import {FlowType} from "../features/QueuePaymenrt/constants/flowType";
import {CopyBook} from "../features/QueuePaymenrt/helpers/copyBook";
import {useMemo, useRef, useState} from "react";
import {Project} from "@brg/api";
import {useDispatch, useSelector} from "react-redux";
import {useGetBookCopyCard} from "./api/Book/useGetBookCardCopy";
import {useTranslation} from "react-i18next";
import {useToasts} from "@brg/ui";
import {useModal} from "../../core";
import {useBookCard} from "./api/Book/useBookCard";
import {BookDelegate} from "../../_deziiign/books/core/book-delegate";
import {useGetAdditionalItems} from "./api/Shop/useGetAdditionalItems";
import {useGetNewBookPrice} from "./api/Book/useGetNewBookPrice";

export interface BookPaymentData {
    onBuy: any,
    additionalItems: any,
    bookCard: any,
    bookCardId: any,
    copyCard: any,
    isLoadingCard: any,
    price: any,
    priceLoading: any,
    setBookPaymentInfoTime: any,
}

export const useGetBookPaymentData = (project?: Project, notIncludeProducts?: boolean): BookPaymentData => {

    const { t, i18n } = useTranslation()
    const toasts = useToasts()
    const modal = useModal()
    const isCopying = useRef(false)

    const projectOrBookId = useMemo(() => project?.book? project.book.bookId : project?.projectId, [project])

    const isPaidBook: any = useMemo(() => BookDelegate.isPaid(project?.book || project) && (project?.isBook || project?.book), [project])

    const [additionalItems, isLoadingCard] = useGetAdditionalItems(project?.book?.bookId || project?.projectId, isPaidBook, Boolean(project?.book?.bookId || project?.isBook))
    const [time, setTime] = useState(Date.now())
    const dispatch = useDispatch()
    const { bookCard } = useSelector(selectorOrder)
    const {copyCard, isLoading: isBookPurchasedLoading} = useGetBookCopyCard(isPaidBook ? projectOrBookId : "", time)
    const {
        cardId: bookCardId,
        isLoading: isBookCardLoading,
        error: bookCardError
    } = useBookCard((copyCard || isBookPurchasedLoading) ? "" : (projectOrBookId || ""), !isPaidBook)
    const {resp: price, isLoading: priceLoading } = useGetNewBookPrice(bookCardId || undefined)

    const onBuy = () => {

        if (!price || copyCard || priceLoading) {
            return
        }

        const buyCopyStartUrl = window.location.href;
        localStorage.setItem('buy_copy_start_path', buyCopyStartUrl);
        dispatch(clearFlowFields(FlowType.COPY_BOOK));
        dispatch(setActiveTariff(null));
        dispatch(setAvailableTariffs([]));
        // TODO пока хз как новая оплата будет работать
        CopyBook(project?.book || project, additionalItems, bookCard, price?.priceZephyr?.zephyr + 1, isCopying, {dispatch, t, i18n, toasts, modal})
    }

    return {
        onBuy,
        additionalItems,
        bookCard,
        copyCard,
        bookCardId,
        isLoadingCard,
        price,
        priceLoading,
        setBookPaymentInfoTime: setTime
    }
}import {
    clearFlowFields,
    selectorOrder,
    setActiveTariff,
    setAvailableTariffs
} from "../features/QueuePaymenrt/slices/OrderSlice";
import {FlowType} from "../features/QueuePaymenrt/constants/flowType";
import {CopyBook} from "../features/QueuePaymenrt/helpers/copyBook";
import {useMemo, useRef, useState} from "react";
import {Project} from "@brg/api";
import {useDispatch, useSelector} from "react-redux";
import {useGetBookCopyCard} from "./api/Book/useGetBookCardCopy";
import {useTranslation} from "react-i18next";
import {useToasts} from "@brg/ui";
import {useModal} from "../../core";
import {useBookCard} from "./api/Book/useBookCard";
import {BookDelegate} from "../../_deziiign/books/core/book-delegate";
import {useGetAdditionalItems} from "./api/Shop/useGetAdditionalItems";
import {useGetNewBookPrice} from "./api/Book/useGetNewBookPrice";

export interface BookPaymentData {
    onBuy: any,
    additionalItems: any,
    bookCard: any,
    bookCardId: any,
    copyCard: any,
    isLoadingCard: any,
    price: any,
    priceLoading: any,
    setBookPaymentInfoTime: any,
}

export const useGetBookPaymentData = (project?: Project, notIncludeProducts?: boolean): BookPaymentData => {

    const { t, i18n } = useTranslation()
    const toasts = useToasts()
    const modal = useModal()
    const isCopying = useRef(false)

    const projectOrBookId = useMemo(() => project?.book? project.book.bookId : project?.projectId, [project])

    const isPaidBook: any = useMemo(() => BookDelegate.isPaid(project?.book || project) && (project?.isBook || project?.book), [project])

    const [additionalItems, isLoadingCard] = useGetAdditionalItems(project?.book?.bookId || project?.projectId, isPaidBook, Boolean(project?.book?.bookId || project?.isBook))
    const [time, setTime] = useState(Date.now())
    const dispatch = useDispatch()
    const { bookCard } = useSelector(selectorOrder)
    const {copyCard, isLoading: isBookPurchasedLoading} = useGetBookCopyCard(isPaidBook ? projectOrBookId : "", time)
    const {
        cardId: bookCardId,
        isLoading: isBookCardLoading,
        error: bookCardError
    } = useBookCard((copyCard || isBookPurchasedLoading) ? "" : (projectOrBookId || ""), !isPaidBook)
    const {resp: price, isLoading: priceLoading } = useGetNewBookPrice(bookCardId || undefined)

    const onBuy = () => {

        if (!price || copyCard || priceLoading) {
            return
        }

        const buyCopyStartUrl = window.location.href;
        localStorage.setItem('buy_copy_start_path', buyCopyStartUrl);
        dispatch(clearFlowFields(FlowType.COPY_BOOK));
        dispatch(setActiveTariff(null));
        dispatch(setAvailableTariffs([]));
        // TODO пока хз как новая оплата будет работать
        CopyBook(project?.book || project, additionalItems, bookCard, price?.priceZephyr?.zephyr + 1, isCopying, {dispatch, t, i18n, toasts, modal})
    }

    return {
        onBuy,
        additionalItems,
        bookCard,
        copyCard,
        bookCardId,
        isLoadingCard,
        price,
        priceLoading,
        setBookPaymentInfoTime: setTime
    }
}